import React from 'react';
import { connect } from 'react-redux'
import { IoIosSearch } from 'react-icons/io'
import { bindActionCreators } from "redux";

import Button from "components/Button";

import './search.css'

import { search } from "api/actions";

import TableRow from 'components/TableRow';

class Search extends React.Component {
  onTyping = (e) => {
    if (e.target.value) {
      this.props.search({ q: e.target.value });
    }
  };

  render() {
    return (
      <div
        className={'search-container'}
        onClick={this.props.onHide}
      >
        <div
          onClick={e => e.stopPropagation()}
        >
          <div
            className={'search-input-container'}
          >
            <Button
              style={{
                width: 30,
                height: '100%',
                backgroundColor: 'transparent',
                color: '#C1C7CD',
                fontSize: 20
              }}
            >
              <IoIosSearch />
            </Button>
            <input
              className={'search-input'}
              type="text"
              placeholder={'Search'}
              onChange={this.onTyping}
            />
          </div>
          <div
            style={{
              maxHeight: '80vh',
              overflow: 'scroll'
            }}
          >
            {this.props.objects.map(info =>
              <TableRow
                canSelect={false}
                key={info.Key}
                {...info}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

Search.defaultProps = {
  objects: []
};

const mapStateToProps = (state) => ({
  objects: state.objects,
  type: state.type,
});

const dispatchToProps = (dispatch) => {
  return bindActionCreators({ search }, dispatch)
};


export default connect(mapStateToProps, dispatchToProps)(Search);